import { jsx as R } from "react/jsx-runtime";
import d from "../../../ui-kit/theme-button.mjs";
import { useStore as b } from "../../../store/index.mjs";
import { BadRequest as h } from "@systemeio/util";
import { useRazorpayBuyOffer as w } from "../api/razorpay-api.mjs";
import B from "../hooks/useRazorpay.mjs";
function v({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: a,
  setIsFetching: o,
  handleBadRequest: n,
  preSubmit: s
}) {
  const { locale: i } = b(), { razorpayBuyOffer: p } = w(), { generateOptions: f, isRazorpayReady: m, Razorpay: y, isRazorpayFetching: u } = B();
  return /* @__PURE__ */ R(
    d,
    {
      disabled: a,
      type: "submit",
      onClick: async (c) => {
        c.preventDefault(), o(!0);
        try {
          const r = s();
          if (!r) return;
          const l = await p(r, i), z = f(l);
          if (m)
            new y(z).open();
          else
            throw new Error("form submitted before razorpay was ready");
        } catch (r) {
          if (r instanceof h)
            n(r);
          else
            throw r;
        } finally {
          o(!1);
        }
      },
      isFetching: t || u,
      children: e
    }
  );
}
export {
  v as RazorpayPaymentButton
};
